import styled, { css } from 'styled-components';

interface MaxWidthProps {
  $maxWidth: string;
}

export const MaxWidth = styled.div.withConfig({ componentId: 'sc-v6u1os-0' })<MaxWidthProps>`
    ${({ $maxWidth }) =>
      $maxWidth &&
      css`
            max-width: ${$maxWidth};
        `}
`;
